import * as Yup from 'yup';
import { SarlaftFinancial } from '../../../../../../shared/types/modules/sarlaft';

export const initialValues: SarlaftFinancial = {
    annualIncome: '',
    assets: '',
    annualExpenditure: '',
    liabilities: '',
    otherAnnualIncome: '',
    otherIncome: '',
};

export const validationSchema = Yup.object({
    annualIncome: Yup.string().required(
        'Los ingresos anueales son obligatorios'
    ),
    assets: Yup.string().required('Los activos son obligatorios'),
    annualExpenditure: Yup.string().required(
        'Los egresos anuales son obligatorios'
    ),
    liabilities: Yup.string().required('Los pasivos son obligatorios'),
    otherAnnualIncome: Yup.string(),
    otherIncome: Yup.string(),
});
